import { useDispatch } from 'react-redux';
import { Message } from '@blink/components/src/constants/messages';
import { WalletHelper } from '@blink/components/src/utils';

import { OperationStatusType } from '@/features/Modals/ui/OperationStatusModal';
import { useEthers } from '@/shared/hooks/useEthers';
import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';
import { getAssetsToSupplyAction, getUsersSupplies } from '@/shared/store/supplies/actions';
import { depositErrorAction } from '@/shared/store/errors/actions';
import { toast } from '@/shared/hooks/useToast';

type MakeSupplylProps = {
    amount: string;
    agreementAddress: string;
    marginAccountAddress: string;
    tokenAddress: string;
};

export const useVaultMarginAccountSupply = () => {
    const dispatch = useDispatch();
    const { depositVault } = useEthers();

    const handleError = (e: any) => {
        dispatch(
            showModalAction({
                modalName: ModalName.OPERATION_STATUS_MODAL,
                modalProps: {
                    type: OperationStatusType.Error,
                    description: e.info?.error?.message || Message.DEFAULT_ERROR,
                },
            }),
        );
    };

    const makeSupply = async ({
        amount,
        agreementAddress,
        marginAccountAddress,
        tokenAddress,
    }: MakeSupplylProps) => {
        const commonVariables = {
            amount: amount?.toString() || '0',
            poolAddress: agreementAddress,
            marginAccountAddress,
            tokenAddress,
            orderPlacedCallback: () =>
                dispatch(
                    showModalAction({
                        modalName: ModalName.OPERATION_STATUS_MODAL,
                        modalProps: {
                            type: OperationStatusType.Success,
                            description: Message.SUPPLY_ORDER_PLACED,
                        },
                    }),
                ),
            receiptReceivedCallback: (data: any) => {
                if (data.status === 1) {
                    toast({
                        title: Message.TRANSACTION_COMPLETED,
                        variant: 'success',
                    });
                    dispatch(getUsersSupplies());
                    dispatch(getAssetsToSupplyAction());

                    return;
                }

                throw data.error || Message.DEFAULT_ERROR;
            },
        };

        try {
            await depositVault(commonVariables);
        } catch (e: any) {
            const badMessage = WalletHelper.messageInCaseOfNotCorrectNetwork(e);

            dispatch(
                depositErrorAction({
                    message: badMessage || e.info?.error?.message || Message.DEFAULT_ERROR,
                }),
            );

            handleError(e);
        }
    };

    return {
        makeSupply,
    };
};
